import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/vacation-luggage-storage-and-shipping.jpg'),
    alt: 'vacation luggage storage and shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'vacation luggage storage and shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Vacation <span>Luggage</span><span>Storage And Shipping Services</span>',
  description:
    "Travel stress-free with our Vacation Luggage Storage and Shipping solutions. Whether you're exploring a new city or heading to a dream destination, we ensure your luggage is safely stored and shipped for a seamless travel experience.",
  image: {
    url: '/images/v2/pages/landing-pages/vacation-luggage-storage-and-shipping/hero-image.jpg',
    alt: 'Vacation Luggage Storage And Shipping Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up Now' }
}

export const ourProcessSectionContent = {
  title: 'Fast Vacation Luggage Shipping Solutions',

  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Book Your Storage Now' },

  image: {
    url: '/images/v2/pages/landing-pages/vacation-luggage-storage-and-shipping/fast-vacation-luggage-shipping-solutions.png',
    alt: 'Fast Vacation Luggage Shipping Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description: 'Schedule your luggage shipping and storage in just a few clicks.',
      image: {
        src: '/images/v2/pages/common/easy-booking-tracking.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Reliable Pickup & Delivery',
      description: 'We collect your luggage from your location and deliver it safely.',
      image: {
        src: '/images/v2/pages/common/secure-packaging-labeling.png',
        alt: 'Reliable Pickup & Delivery'
      }
    },
    {
      id: 3,
      title: 'Timely & Secure Transit',
      description: 'Your belongings are shipped quickly with tracking updates.',
      image: {
        src: '/images/v2/pages/common/fast-and-reliable-delivery.png',
        alt: 'Timely & Secure Transit'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure Vacation Luggage Storage Solutions',
  description:
    'We offer secure, climate-controlled storage to keep your belongings safe while you travel. Our storage facilities are monitored 24/7, protecting your luggage from theft, temperature changes, and humidity. Whether you need short-term or long-term storage, we provide flexible solutions to match your travel plans.',
  image: {
    src: '/images/v2/pages/landing-pages/vacation-luggage-storage-and-shipping/secure-vacation-luggage-storage-solutions.jpg',
    alt: 'Secure Vacation Luggage Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Our Vacation Luggage Storage and Shipping',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description:
        'Travel light without carrying heavy bags. We handle storage and shipping, so you can focus on enjoying your trip.',
      image: {
        src: '/images/v2/pages/common/convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Security',
      description:
        'Your belongings are kept in a fully monitored and climate-controlled facility, ensuring maximum protection.',
      image: {
        src: '/images/v2/pages/common/security.png',
        alt: 'Security'
      }
    },
    {
      id: 3,
      title: 'Flexibility',
      description:
        'We offer both short-term and long-term storage options, so you can store your luggage for as long as needed.',
      image: {
        src: '/images/v2/pages/common/improved-compliance.png',
        alt: 'Flexibility'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Vacation Luggage Storage?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Frequent Travelers',
          description:
            'Skip the hassle of dragging luggage through airports and train stations. Ship and store your bags effortlessly.'
        },
        {
          id: 2,
          title: 'Families on Vacation',
          description: 'Avoid carrying multiple suitcases. Store excess luggage and travel with only the essentials.'
        },
        {
          id: 3,
          title: 'Business Travelers',
          description: 'Keep your focus on work while we take care of your luggage shipping and storage needs.'
        },
        {
          id: 4,
          title: 'Adventure Seekers',
          description:
            'Need a place to store your sports gear, like skis or golf clubs? We offer secure storage for all types of travel equipment.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/vacation-luggage-storage-and-shipping/who-should-choose-us-for-vacation-luggage-storage.jpg',
        alt: 'Who Should Choose Us for Vacation Luggage Storage?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Residential Storage',
      description:
        "Store household items safely while you're away. Perfect for seasonal storage or temporary relocation needs.",
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Residential Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage',
      description:
        'Store your belongings temporarily during a move. Our storage solutions help make relocation stress-free.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage',
      description:
        'Ideal for businesses needing extra space for documents, equipment, or inventory. Secure and flexible options available.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'College Storage',
      description:
        'Students can store dorm room essentials over summer breaks or during semester transitions with our secure college storage services.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'College Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Vacation Luggage Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/vacation-luggage-storage-and-shipping/why-choose-us-for-vacation-luggage-storage-solutions.jpg',
    alt: 'Why Choose Us for Vacation Luggage Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Pricing',
      description: 'We offer budget-friendly Vacation Luggage Storage and Shipping solutions with no hidden fees.'
    },
    {
      id: 2,
      title: 'Real-Time Tracking',
      description:
        'Easily track your luggage’s location and status with our advanced tracking system, giving you peace of mind.'
    },
    {
      id: 3,
      title: 'Secure Facilities',
      description:
        'Our climate-controlled storage units are monitored 24/7 to protect your belongings from damage and theft.'
    },
    {
      id: 4,
      title: 'Flexible Storage Plans',
      description:
        'Choose from short-term or long-term storage plans based on your travel schedule. We offer convenient options to fit your needs.'
    },
    {
      id: 5,
      title: 'Door-to-Door Service',
      description: 'We pick up and deliver your luggage directly to your desired location, saving you time and effort.'
    },
    {
      id: 6,
      title: 'Reliable Customer Support',
      description:
        'Our support team is available 24/7 to assist with any queries regarding your Vacation Luggage Storage and Shipping.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Vacation Luggage Storage And Shipping Solutions Fast',
  description:
    'Vacation luggage storage and shipping solutions available. Fast and secure services for storing and shipping luggage during vacations.',
  image: {
    src: '/images/v2/pages/landing-pages/vacation-luggage-storage-and-shipping/vacation-luggage-storage-and-shipping-solutions-fast.png',
    alt: 'Vacation Luggage Storage And Shipping Solutions Fast'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Reserve Your Spot' }
}

export const ourPartnersSectionContent = {
  title: 'Trusted Shipping Partners',
  description:
    'We collaborate with top-tier shipping companies to provide secure, reliable, and efficient shipping solutions tailored to your needs.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures fast and dependable shipping services, guaranteeing the safe and timely delivery of your office equipment.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference purposes only. FedEx does not guarantee the accuracy or completeness of the information provided. For the latest details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL specializes in international shipping, offering seamless solutions for office equipment storage, transportation, and retrieval.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference purposes only. DHL does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS delivers reliable shipping services, ensuring the safe and secure transportation of your stored office equipment.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference purposes only. UPS does not guarantee the accuracy or completeness of the information provided. For the latest updates, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
